/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CenterBoxStake.vue?vue&type=template&id=52f4c920&scoped=true"
import script from "./CenterBoxStake.vue?vue&type=script&lang=js"
export * from "./CenterBoxStake.vue?vue&type=script&lang=js"
import style0 from "./CenterBoxStake.vue?vue&type=style&index=0&id=52f4c920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4c920",
  null
  
)

export default component.exports